<template>
<!--  prepend-icon="mdi-filter-variant"-->


  <v-combobox
      v-model="input"
      chips
      clearable
      :label="label"
      multiple
      append-icon=""
      outlined>
    <template v-slot:selection="{ attrs, item, select, selected ,index}">
      <v-chip
          label
          v-bind="attrs"
          :input-value="selected"
          close
          @click="select"
          @click:close="remove(item)"
      >
        <strong>{{ item }}</strong>&nbsp;
      </v-chip>
    </template>
  </v-combobox>

</template>

<script>

export default {
  props: ['value', 'errors','dense', 'return_object','label'],

  data() {
    return {
      input: this.value,
    }
  },
  methods:{
    remove (item) {
      this.input.splice(this.input.indexOf(item), 1)
      this.$emit('input', this.input)
    },},
  name: "siteSelect",
  watch : {
    input(){
      this.$emit('input', this.input)
    }
  }
}
</script>

<style scoped>

</style>